import { render } from "./OralHygieneExperts.vue?vue&type=template&id=5e512da6&scoped=true"
import script from "./OralHygieneExperts.vue?vue&type=script&lang=js"
export * from "./OralHygieneExperts.vue?vue&type=script&lang=js"

import "./OralHygieneExperts.vue?vue&type=style&index=0&id=5e512da6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e512da6"]])

export default __exports__